$(document).ready(function () {

    /*--Overflow scroll glitch fix---*/

    let div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';

    document.body.append(div);
    let scrollWidth = div.offsetWidth - div.clientWidth;
    div.remove();

    /*------ MODALS ---------*/
    let renderClickableBG = (isDark, elementToClose, renderParent = $('body'), blockScroll = true, id = "default-clickable-bg") => {
        renderParent.append(`<div class="clickable-bg" id=${id}></div>`);
        if (blockScroll) {
            $('body').css({
                'padding-right': scrollWidth,
                'overflow-y': 'hidden',
            });
        }
        if (isDark) {
            $('.clickable-bg').addClass('clickable-bg--dark').fadeOut(1).fadeIn(400);
        }
        $('.clickable-bg').on('click', function () {
            $(this).remove();
            if (elementToClose) {
                elementToClose.removeClass('opened');
                if (blockScroll) {
                    $('body').css({
                        'padding-right': 0,
                        'overflow-y': 'auto',
                    });
                }
            }
        })
    }

    const openModal = (modalId) => {
        $('.modal').removeClass('opened')
        let modalToOpen = $(modalId);
        modalToOpen.addClass('opened').fadeOut(1).fadeIn(400);
        renderClickableBG(true, modalToOpen, modalToOpen);
    }

    const closeModal = (modalId) => {
        let modalToClose = $(modalId)
        modalToClose.removeClass('opened');
        $('body').css({
            'padding-right': 0,
            'overflow-y': 'auto',
        });
        modalToClose.find(('.clickable-bg')).remove();
    }

    $(document).on('click', '.js-open-modal', function () {
        let dataModal = $(this).attr('data-modal');
        openModal(dataModal);
    })

    $(document).on('click', '.js-close-modal', function (e) {
        let vThis = $(e.target);
        closeModal('#' + vThis.parents('.modal')[0].id)
    })

    /*------ MOBILE MENU ---------*/
    $('.js-open-mobile-menu').on('click', function () {
        $('.mobile-menu').addClass('opened');
        renderClickableBG(true, $('.mobile-menu'))
    })

    $('.js-close-mobile-menu').on('click', function () {
        $('.mobile-menu').removeClass('opened');
        $('.clickable-bg').remove();
        $('body').css({
            'padding-right': 0,
            'overflow-y': 'auto',
        });
    })

    /*------ INPUTS ---------*/

    $('.js-open-popup').on('click', function () {
        $('#popup-bg').remove();
        $('.js-open-popup').removeClass('opened');
        let popup = $(this).parent().find('.js-popup');
        popup.toggleClass('opened');
        renderClickableBG(false, popup, $('body'), false, 'popup-bg');
    })

    $('.js-custom-select .custom-select-option').on('click', function () {
        let optionValue = $(this).text();
        let optionsWrapper = $(this).parents('.custom-select-options');
        let customSelect = $(this).parents('.js-custom-select');
        customSelect.find('.custom-select__value').text(optionValue);
        setTimeout(function () {
            $('#popup-bg').remove();
        }, 50);
        optionsWrapper.removeClass('opened');
        customSelect.find('.custom-select__value').removeClass('default');
        customSelect.find('option').each(function () {
            if ($(this).text() === optionValue) {
                customSelect.find('select').val(optionValue).change();
            }
        })
    })

    $('.js-checkbox').on('click', function (e) {
        if (e.target.tagName.toLowerCase() !== 'a') {
            e.preventDefault()
            let isChecked = $(this).find('.custom-checkbox').prop('checked');
            $(this).toggleClass('checked').find('.custom-cb-badge').toggleClass('checked');
            $(this).find('.custom-checkbox').prop('checked', !isChecked);
        }
    });

    $('.js-input-edit').on('click', function () {
        let input = $(this).siblings('.input-common');
        if (!input.hasClass('enabled')) {
            input.attr('disabled', false).addClass('enabled').focus();
            $(this).find('span').text('Сохранить');
        } else {
            input.attr('disabled', true).removeClass('enabled');
            $(this).find('span').text('Редактировать');
        }
    });

    $('#ao-datepicker').datepicker({
        onSelect: function(date, formatted, datepicker){
            datepicker.$el.change();
        }
    });
    $('.form-group--date input').datepicker();



    function setPhones()
    {
        let elements = document.querySelectorAll("input[type='tel']");
        elements.forEach(function (element) {
            let dynamicMask = IMask(element, {
                mask: [
                    {
                        mask: '+{7}(#00)000-00-00',
                        definitions: {
                            '#': /[12345690]/
                        }
                    },
                    {
                        mask: '{#}(000)000-00-00',
                        definitions: {
                            '#': /[8]/
                        }
                    }, {
                        mask: '{+#}(000)000-00-00',
                        definitions: {
                            '#': /[+7]/
                        }
                    },
                ]
            });
        })
    }
    setPhones();

    /*------ MAP ---------*/

    function loadScript(url, callback) {

        var script = document.createElement("script");

        if (script.readyState) {  //IE
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" ||
                    script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }

    //Айдишники и параметры карт для загрузки

    function init() {
        // Создание карт.
        function prepareMap() {

            let mapJsonPath = 'data/map.json';
            let myGeoObjects = [];
            let objectsCounter = 0;
            $.getJSON(mapJsonPath, function (data) {
                data.forEach(point => {
                    objectsCounter++;
                    let balloonInner =
                        `<div class="custom-balloon">
                                <div class="custom-balloon__bg"></div>
                                <div class="custom-balloon__text"><b>${point.name}</b></div>
                                <div class="custom-balloon__text">${point.address}</div>
                                <div class="custom-balloon__text">Режим работы: ${point.worktime}</div>
                         </div>`

                    let placemark = new ymaps.Placemark(point.coords, {
                            balloonContent: balloonInner,
                        },
                        {
                            hideIconOnBalloonOpen: false,
                            balloonOffset: [4, -37],
                            iconLayout: 'default#image',
                            iconImageHref: 'img/svg/marker.svg',
                        });


                    myGeoObjects.push(placemark)
                })

                var myMap = new ymaps.Map('map-container', {
                    center: data[0].coords,
                    zoom: 13,
                    controls: ['zoomControl'],
                });

                myGeoObjects.forEach(item => {
                    myMap.geoObjects.add(item);
                })
                myMap.behaviors.disable('scrollZoom');

            })


        }

        prepareMap()

    }

    let check_if_load = false;
    const checkLoadMap = () => {
        if (!check_if_load) {
            check_if_load = true;
            loadScript("https://api-maps.yandex.ru/2.1/?apikey=04709a29-6f21-442a-9cb5-272b39900456&lang=ru_RU", function () {
                ymaps.ready(init);
            });
        }
    }

    let checkVisible = (elem, eventName, callback) => {
        let i = 0;
        let elemsNum = elem.length;

        elem.each(function () {
            i = callback($(this), i);
            if (i >= elemsNum) {
                $(document).off(`scroll.${eventName}`);
            }
        });

        $(document).on(`scroll.${eventName}`, function () {
            elem.each(function () {
                i = callback($(this), i);
                if (i >= elemsNum) {
                    $(document).off(`scroll.${eventName}`);
                }
            });
        });
    }

    if ($('.map-container').length > 0) {
        checkVisible($('.map-container'), 'scroll.map-container', function (vThis, i) {
            if (vThis.visible(true) && !vThis.hasClass('visible')) {
                vThis.addClass('visible');
                checkLoadMap();
                i++;
            }
            return i;
        });
    }

    /*------ MISC ---------*/

    $('.js-toggle-select').on('click', function () {
        $(this).parent().children().removeClass('selected')
        $(this).addClass('selected');
    })

    $('.delivery-type-toggle .js-toggle-select').on('click', function () {
        $(this).parents('.delivery-type-toggle').find('.delivery-type-toggle__text').removeClass('selected');
        $(this).find('input').prop("checked", true);
        $(this).parents('.delivery-type-toggle').find('.delivery-type-toggle__text').eq($(this).index()).addClass('selected');
    })

    let moveElement = (element, target, screenSize, append = true, after = false) => {
        if (screen.width < screenSize) {
            if (after) {
                for (let i = 0; i < $(element).length; i++) {
                    $(target).eq(i).after($(element).eq($(target).length === 1 ? 0 : i))
                }
            } else {
                if (append) {
                    for (let i = 0; i < $(element).length; i++) {
                        $(element).eq(i).appendTo($(target).eq($(target).length === 1 ? 0 : i))
                    }
                } else {
                    for (let i = 0; i < $(element).length; i++) {
                        $(element).eq(i).prependTo($(target).eq($(target).length === 1 ? 0 : i))
                    }
                }
            }
        }
    }

    moveElement('.header__auth', '.mobile-menu', 991);
    moveElement('.header__btn--track', '.mobile-menu', 991);
    moveElement('.header__nav', '.mobile-menu', 991);
    moveElement('.callback-fixed', '.mobile-menu', 1377);
    moveElement('.header__phone', '.header__bottom-inner', 991);
    moveElement('.header__btn--order-delivery', '.header__bottom-inner', 991);
    moveElement('.delivery-calc__fg-wrapper--type', '.delivery-calc__left', 767);
    moveElement('.delivery-calc__fg-wrapper--sizes', '.delivery-calc__right', 767, false);
    moveElement('.tracking__notation', '.tracking__table .grid-table__tbody .grid-table__tr:first-child .grid-table__td:last-child', 767);
    // moveElement('.js-delivery-type-toggle', '.js-delivery-type-toggle-container', 769);

    function moveDelyvetyTypeToggle() {
        if (screen.width < 769) {
            $('.js-delivery-type-toggle-container-m').append($('.js-delivery-type-toggle'));
        } else {
            $('.js-delivery-type-toggle-container').prepend($('.js-delivery-type-toggle'));
        }
    }

    moveDelyvetyTypeToggle();

    $(window).resize(function() {
        moveDelyvetyTypeToggle();
    });

    let scrollTo = (target) => {
        $([document.documentElement, document.body]).animate({
            scrollTop: target.offset().top - $('header').height()
        }, 1000);
    }

    $('.js-scroll-to').on('click', function () {
        $('.mobile-menu').removeClass('opened');
        $('.clickable-bg').remove();
        $('body').css({
            'padding-right': 0,
            'overflow-y': 'auto',
        });

        let target = $(this).attr('data-scroll');
        scrollTo($(target));
    })

    $(document).on('click', '.js-open-order-details', function () {
        $(this).toggleClass('opened');
        $(this).next().slideToggle()
    })

    $('.js-change-delivery-type').on('click', function () {

        $('.custom-select-option').eq(Number($(this).attr('data-delivery'))).trigger('click');
    })

    $('.js-custom-select .custom-select-option').on('click', function () {
        let optionValue = $(this).attr('data-value');
        let optionText = $(this).text();
        let optionsWrapper = $(this).parents('.custom-select-options');
        let customSelect = $(this).parents('.js-custom-select');
        customSelect.find('.custom-select__value').text(optionText);
        setTimeout(function () {
            $('#popup-bg').remove();
        }, 50);
        optionsWrapper.removeClass('opened');
        customSelect.find('.custom-select__value').removeClass('default');
        customSelect.find('option').each(function () {
            if ($(this).val() === optionValue) {
                customSelect.find('select').val(optionValue).change();
            }
        })
    })


    // формы входа и регистрации
    $(document).on('submit', '#login-form, #reg-form, #account-form', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        let t = this;
        $('.error-message', t).each(function () {
            $(this).text('').hide();
        });

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {

                if (data.status == 'ok') {

                    if ($(t).attr('id') == 'account-form') {
                        alert(data.message);
                    } else {
                        document.location.href = '/account/';
                    }

                } else {
                    $.each(data.errors, function (index, value) {
                        $('#' + data.form_name + '-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });

        return false;
    });

    // восстановление пароля
    $(document).on('submit', '#forget-form, #reset-form', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        let t = this;
        $('.error-message', t).each(function () {
            $(this).text('').hide();
        });

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {

                if (data.status == 'ok') {
                    // clear form
                    $(t)[0].reset();
                    alert(data.message);
                    if ($(t).attr('id') == 'reset-form') {
                        document.location.href = '/account/login/';
                    }
                } else {
                    $.each(data.errors, function (index, value) {
                        $('#' + data.form_name + '-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });

        return false;
    });

    // обратная связь
    $(document).on('submit', '#feedback-form', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        let t = this;
        $('.error-message', t).each(function () {
            $(this).text('').hide();
        });

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {

                if (data.status == 'ok') {
                    // clear form
                    $(t)[0].reset();
                    alert(data.message);
                    closeModal('#modal-feedback-application');

					console.log('feedback-form');
					ym(88596771, 'reachGoal', 'feedback-form');
					gtag('event', 'ok', { 'event_category': 'feedback-form'});

                } else {
                    $.each(data.errors, function (index, value) {
                        $('#feedback-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });

        return false;
    });

    // Калькулятор доставки
    $(document).on('submit', '#calculator-form', function (e) {

        var calcForm = $(this);
        var courierForm = $('#courier-form');

        e.preventDefault();
        e.stopImmediatePropagation();

        let t = this;
        $('.error-message', t).each(function () {
            $(this).text('').hide();
        });

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {

                if (data.status == 'ok') {
                    // clear form
                    //$(t)[0].reset();
                    $('#modal-calc-results > div.modal__inner').html(data.resultHtml);
                    //$('#order-comment').val(data.orderComment);
                    openModal('#modal-calc-results');

                    var length = calcForm.find('[name="Calculator[length]"]').val();
                    var width = calcForm.find('[name="Calculator[width]"]').val();
                    var height = calcForm.find('[name="Calculator[height]"]').val();
                    var weight = calcForm.find('[name="Calculator[weight]"]').val();

                    var package_type = calcForm.find('[name="Calculator[package_type]"]:checked').val();
                    var delivery_type = calcForm.find('[name="Calculator[delivery_type]"]').val();
                    var from_address = calcForm.find('[name="Calculator[from_address]"]').val();
                    var to_address = calcForm.find('[name="Calculator[to_address]"]').val();

                    courierForm.find('[name="Order[sender_city]"]').val($('#calculator-from_city').val());
                    courierForm.find('[name="Order[recipient_city]"]').val($('#calculator-to_city').val());

                    courierForm.find('[name="Order[sender_address]"]').val(from_address);
                    courierForm.find('[name="Order[recipient_address]"]').val(to_address);

                    courierForm.find('[name="Order[length]"]').val(length);
                    courierForm.find('[name="Order[width]"]').val(width);
                    courierForm.find('[name="Order[height]"]').val(height);
                    courierForm.find('[name="Order[weight]"]').val(weight);

                    courierForm.find('[name="Order[price]"]').val(data.price);
                    courierForm.find('[name="Order[days]"]').val(data.days);

                    courierForm.find('[name="Order[package_type]').closest('.js-custom-select').find('[data-value="'+package_type+'"]').click();
                    courierForm.find('[name="Order[delivery_type]').closest('.js-custom-select').find('[data-value="'+delivery_type+'"]').click();

                    setPhones();

					console.log('calculator-form');
					ym(88596771, 'reachGoal', 'calculator-form');
					gtag('event', 'ok', { 'event_category': 'calculator-form'});
                } else {
                    $.each(data.errors, function (index, value) {
                        $('#calculator-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });

        return false;
    });

    // замена запятой на точку в весе
    $(document).on('input', '#calculator-weight', function(e){
        e.preventDefault();
        $(this).val($(this).val().replace(',', '.'));
    });

    // Вызов курьера
    $(document).on('submit', '#courier-form', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        let t = this;
        $('.error-message', t).each(function () {
            $(this).text('').hide();
        });

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {

                if (data.status == 'ok') {
                    // clear form
                    $(t)[0].reset();
                    alert(data.message);
                    closeModal('#modal-call-courier');

					console.log('courier-form');
					ym(88596771, 'reachGoal', 'courier-form');
					gtag('event', 'ok', { 'event_category': 'courier-form'});

                } else {
                    $.each(data.errors, function (index, value) {
                        $('#order-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });

        return false;
    });


    // обратная связь при неудачном поиске
    $(document).on('submit', '#feedback-fail-form', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        let t = this;
        $('.error-message', t).each(function () {
            $(this).text('').hide();
        });

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {

                if (data.status == 'ok') {
                    // clear form
                    $(t)[0].reset();
                    alert(data.message);
                    closeModal('#modal-call-courier');

                    //console.log('courier-form');
                    // ym(88596771, 'reachGoal', 'courier-form');
                    // gtag('event', 'ok', { 'event_category': 'courier-form'});

                } else {
                    $.each(data.errors, function (index, value) {
                        $('#order-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });

        return false;
    });


    // трекинг
    $(document).on('input change', '#tracking', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        $('#tracking').siblings('.error-message').hide();
        $('.tracking__results').html('').hide();

        $.ajax({
            url: $(this).closest('form').attr('action'),
            type: 'get',
            dataType: 'json',
            data: 'tracking=' + $(this).val(),
            success: function (data) {
                if (data.status == 'ok') {
                    // clear form
                    //$(t)[0].reset();
                    $('.tracking__results').html(data.resultHtml).show();
                }
                else
                {
                    $('.tracking__results').html('').hide();
                }
            },

        });

        return false;
    });

    // фильтры в личном кабинете
    $(document).on('input change', '.js_order_filter', function (e) {

        e.preventDefault();

        $.ajax({
            url: $(this).attr('action'),
            type: $(this).closest('form').attr('method'),
            dataType: 'json',
            data: $(this).closest('form').serialize(),
            success: function (data) {

                if (data.status == 'ok') {
                    $('#orders').html(data.ordersHtml).show();

                } else {
                    $.each(data.errors, function (index, value) {
                        $('#feedback-' + index, t).siblings('.error-message').text(value[0]).show();
                    });
                }
            },

        });
    });

    $('.js-hidden-toggle-btn').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('.js-hidden-toggle-content').toggleClass('active');
    });

    $('.js-scroll-top-arrow').on('click', function () {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    $(window).on('scroll', function () {
        if (window.scrollY > screen.height) {
            $('.js-scroll-top-arrow').addClass('show')
        }
        else {
            $('.js-scroll-top-arrow').removeClass('show')
        }
    });

    $(document).on('submit', '.js-tracking', function () {
        return false;
    });
});




